import Repository from '../Repository';

const url = '/account';

export default {
    getData() {
        return Repository.get(`${url}/`);
    },
    getAddresses() {
        return Repository.get(`${url}/addresses`);
    },
    update(payload) {
        return Repository.patch(`${url}/`, payload);
    },

    getQuestionAnswers() {
        return Repository.get(`${url}/questions`, {localLoading: true});
    },

    updateQuestionAnswers(payload) {
        return Repository.patch(`${url}/questions`, payload, {localLoading: true});
    },

    getAddress(type = 'invoice') {
        return Repository.get(`${url}/addresses/${type}`, {localLoading: true});
    },

    updateAddress(id, payload) {
        return Repository.patch(`${url}/addresses/${id}`, payload, {localLoading: true});
    }
}
